import { LEGAL_URL } from "@/components/PublicFooter";

// Inline legal-acceptance checkbox used on every flow that submits user data
// without prior login: PublicRequestPage, RegisterAgencyPage, RegisterClientPage.
// Single external link target — we never duplicate legal content in-app.
export default function LegalAcceptCheckbox({ checked, onChange, testid = "legal-accept" }) {
  return (
    <label
      data-testid={`${testid}-row`}
      className="flex items-start gap-2 text-xs text-zinc-300 cursor-pointer select-none"
    >
      <input
        data-testid={testid}
        type="checkbox"
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
        required
        className="mt-0.5 accent-amber-500 shrink-0"
      />
      <span>
        J'accepte les{" "}
        <a
          data-testid={`${testid}-link`}
          href={LEGAL_URL}
          target="_blank"
          rel="noopener noreferrer external"
          onClick={(e) => e.stopPropagation()}
          className="text-amber-500 hover:text-amber-400 underline"
        >
          conditions générales d'utilisation et de vente
        </a>
      </span>
    </label>
  );
}
